import request from '../../rest/request'

export function sendData(serverUrl: string, endpoint: string, data: any) {
  return request(serverUrl, `${endpoint}`, {
    method: 'POST',
    body: JSON.stringify(data),
    headers: {
      'Content-Type': 'application/json',
    },
  })
}
